module.exports = "<div id=refer_scheme_save> <div class=u-form-group> <label class=\"u-col-4 u-form-group-sm u-form-label text-right\"> 方案编码 </label> <div class=u-col-8> <input type=text data-bind=\"value: model.ref('schemeCode')\"/> </div> </div> <div class=u-form-group> <label class=\"u-col-4 u-form-group-sm u-form-label text-right\"> 方案标题 </label> <div class=u-col-8> <input type=text data-bind=\"value: model.ref('schemeName')\"/> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/evaluationScheme/save/index.html
// module id = 261
// module chunks = 144